import script from "./MintAssetThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./MintAssetThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./MintAssetThumbnail.vue?vue&type=style&index=0&id=b6ef1da8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6ef1da8"]])

export default __exports__